
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
          display:block;
}

  :host .jump-navigation.default .heading {
          flex-grow:1;
}

  :host .jump-navigation.default .heading {
          border-top-left-radius:0.5rem;
          border-top-right-radius:0.5rem;
}

  :host .jump-navigation.default .heading {
          border-width:1px;
}

  :host .jump-navigation.default .heading {
          border-bottom-width:0px;
}

  :host .jump-navigation.default .heading {
          border-style:solid;
}

  :host .jump-navigation.default .heading {
          border-color:var(--bh-brand-primary-default);
}

  :host .jump-navigation.default .heading {
          background-color:var(--bh-brand-primary-default);
}

  :host .jump-navigation.default .heading {
          padding-left:1.25rem;
          padding-right:1.25rem;
}

  :host .jump-navigation.default .heading {
          padding-top:1rem;
          padding-bottom:1rem;
}

  :host .jump-navigation.default .heading {
          font-size:var(--bh-fs-heading-02);
          line-height:var(--bh-lh-heading-02);
          letter-spacing:var(--bh-ls-heading-02);
}

  :host .jump-navigation.default .heading {
          font-weight:var(--fw-bold);
}

  :host .jump-navigation.default .heading {
          color:var(--bh-neutral-white);
}

  :host .jump-navigation.default .items {
          display:flex;
}

  :host .jump-navigation.default .items {
          flex-direction:column;
}

  :host .jump-navigation.default .items {
          border-bottom-right-radius:0.5rem;
          border-bottom-left-radius:0.5rem;
}

  :host .jump-navigation.default .items {
          border-width:1px;
}

  :host .jump-navigation.default .items {
          border-top-width:0px;
}

  :host .jump-navigation.default .items {
          border-style:solid;
}

  :host .jump-navigation.default .items {
          border-color:var(--bh-neutral-default);
}

  :host .jump-navigation.default .items a {
          margin-top:0.75rem;
          margin-bottom:0.75rem;
}

  :host .jump-navigation.default .items a {
          margin-left:1.5rem;
}

  :host .jump-navigation.default .items a {
          overflow:hidden;
}

  :host .jump-navigation.default .items a {
          font-size:var(--bh-fs-heading-02);
          line-height:var(--bh-lh-heading-02);
          letter-spacing:var(--bh-ls-heading-02);
}

  :host .jump-navigation.default .items a {
          font-weight:var(--fw-medium);
}

  :host .jump-navigation.default .items a {
          color:var(--bh-brand-primary-default);
}

  :host .jump-navigation.default .items a {
          text-decoration-line:none;
}

  :host .jump-navigation.default .items a{
          margin-right:calc(1.5rem + 16px);
          transition:margin 250ms ease-in-out;
        }

  :host .jump-navigation.default .items a:first-of-type {
          margin-top:1.5rem;
}

  :host .jump-navigation.default .items a:last-of-type {
          margin-bottom:1.5rem;
}

  :host .jump-navigation.default .items a ghs-icon {
          margin-left:-16px;
}

  :host .jump-navigation.default .items a ghs-icon {
          display:inline-block;
}

  :host .jump-navigation.default .items a ghs-icon{
            transition:margin-left 250ms ease-in-out;
          }

  :host .jump-navigation.default .items a:hover {
          margin-left:1.5rem;
          margin-right:1.5rem;
}

  :host .jump-navigation.default .items a:hover {
          color:var(--bh-neutral-black);
}

  :host .jump-navigation.default .items a:hover ghs-icon {
          margin-left:0px;
}

  :host .jump-navigation.default .items a:hover ghs-icon {
          display:inline-block;
}

  :host .jump-navigation.default.is-mobile .heading {
          border-radius:0px;
}

  :host .jump-navigation.default.is-mobile .heading {
          padding-left:1rem;
          padding-right:1rem;
}

  :host .jump-navigation.default.is-mobile .items {
          border-radius:0px;
}

  :host .jump-navigation.default.is-mobile .items {
          border-color:var(--bh-brand-primary-default);
}

  :host .jump-navigation.default.is-mobile .items {
          background-color:var(--bh-brand-primary-default);
}

  :host .jump-navigation.default.is-mobile .items {
          padding-left:1rem;
          padding-right:1rem;
}

  :host .jump-navigation.default.is-mobile .items {
          padding-bottom:1rem;
}

  :host .jump-navigation.horizontal .items {
          display:flex;
}

  :host .jump-navigation.horizontal .items {
          flex-grow:1;
}

  :host .jump-navigation.horizontal .items {
          justify-content:space-between;
}

  :host .jump-navigation.horizontal a {
          font-family:var(--bh-ff-body);
}

  :host .jump-navigation.horizontal a {
          font-size:var(--bh-fs-heading-03);
          line-height:var(--bh-lh-heading-03);
          letter-spacing:var(--bh-ls-heading-03);
}

  :host .jump-navigation.horizontal a {
          color:var(--bh-brand-primary-default);
}

  :host .jump-navigation.horizontal a {
          text-decoration-line:none;
}

  :host .jump-navigation.horizontal a.disabled {
          cursor:default;
}

  :host .jump-navigation.horizontal a.disabled {
          color:var(--bh-neutral-default);
}

  :host .jump-navigation.horizontal a ghs-icon {
          display:none;
}

:host([variant='default']) {
          width:100%;
}

:host([variant='horizontal']) {
          padding-bottom:9rem;
}
`;